<template>
  <div class="register-page">
    <img src="../assets/face logo.png">
    <user-register
      :phone="phone"
      @userRegistered="onUserRegistered"/>
  </div>
</template>

<script>
  import UserRegister from "../components/UserRegister";

  export default {
    name: "RegisterPage",
    components: {UserRegister},
    data() {
      return {
        phone: null,
        loading: true
      };
    },

    methods: {
      onUserRegistered() {
        this.$router.push({
          name: "UserVisitPreValidationPage"
        })
      }
    },

    created() {
      if (this.$route.query.phone) {
        this.phone = this.$route.query.phone;
      }
      this.loading = false;
    }
  };
</script>

<style lang="scss">
  @import "RegisterPage";
</style>
